<template>
  <b-modal :hide-footer="true" title="Solicitação de vaga criança" centered size="lg" id="gerenciar-vagas-criancas"
    :visible="false" :no-close-on-backdrop="true" :tabindex="0">

    <div>
      <div class="row">
        <div class="col-lg-12">
          <fieldset>
            <legend class="small text text-info">Detalhes da solicitação</legend>
            <div class="row">
              <div class="col-lg-6">
                <form-input label="Nome do solicitante" v-model="data.nome_solicitante" :required="true" />
                <form-input label="Data da solicitação" type="date" v-model="data.data_solicitacao" :required="true" />
                <form-input label="Técnico de referência" v-model="data.tecnico_referencia" :required="true" />
                <form-input label="Telefone da unidade" v-model="data.telefone_unidade" :required="true" />
              </div>
              <div class="col-lg-6">
                <form-input label="Email do solicitante" v-model="data.email_solicitante" type="email" :required="true" />
                <form-select label="Serviço socioassistencial" :itens="servicos"
                  v-model="data.servico_socioassistencial_id" :required="true" @selected="changePublico" />
                <form-input label="Data de início do acompanhamento" type="date" v-model="data.data_inicio_acompanhamento"
                  :required="true" />
                <form-input label="Email da unidade" type="email" v-model="data.email_unidade" :required="true" />
              </div>
            </div>
          </fieldset>
        </div>
        <div class="col-lg-12">
          <fieldset>
            <legend class="small text text-info">Detalhes do usuário</legend>
            <div class="row">
              <div class="col-lg-6">
                <form-input label="Nome completo do usuário" v-model="data.nome_usuario" :required="true" />
                <form-input label="Data de nascimento" v-model="data.nascimento" type="date" />
              </div>
              <div class="col-lg-6">
                <form-input label="Nome social" v-model="data.nome_social" />
                <form-input label="Número do RG" v-model="data.rg" :required="true" />
              </div>
              <div class="col-lg-12">
                <form-select label="Condições de trabalho e rendimento" :itens="profissao" v-model="data.profissao_id"
                  :required="false" />
              </div>
              <div class="col-lg-6">
                <form-select label="Cor, raça e etnia" :itens="raca" v-model="data.raca_id" :required="false" />
                <form-select label="Jovem egresso de saica?" :itens="pergunta" v-model="data.egresso_saica"
                  :required="false" />
                <form-select label="É beneficiário de programa social?" :itens="pergunta"
                  v-model="data.beneficiario_programa_social" :required="false" @selected="checarPrograma" />
                <form-select label="Pessoa com deficiência?" :itens="pergunta" v-model="data.deficiencia"
                  :required="false" />
              </div>
              <div class="col-lg-6">
                <form-select label="Gênero" :itens="genero" v-model="data.genero_id" :required="true"
                  @selected="changePublico" />
                <form-select label="público lgbtqianp+?" :itens="pergunta" v-model="data.lgbt_id" :required="false"
                  @selected="changePublico" />
                <form-select label="Qual programa social?" :itens="programa"
                  :disabled="data.beneficiario_programa_social != 1" v-model="data.programa_social_id"
                  :required="false" />
              </div>
              <div class="col-lg-12">
                <form-select label="qual violação de direitos vivenciada pelo usuário?" :itens="violacoes"
                  v-model="data.violacao_id" :required="false" />
                <form-select label="Grau de dependência (RDC ANVISA 283/2005)" :itens="dependencia"
                  v-model="data.grau_pependencia_id" :required="false" @selected="changePublico" />
              </div>
              <div class="col-lg-6">
                <form-input label="Endereço" v-model="data.endereco" />
              </div>
              <div class="col-lg-6">
                <form-input label="Bairro" v-model="data.bairro" />
              </div>
              <div class="col-lg-12">
                <form-textarea-editor v-model="data.relatorio" grid="12"
                  label="Descreva em seu relatório o acompanhamento ofertado ao usuário neste serviço, justificando a solicitação de acolhimento institucional por terem sido esgotadas todas as demais possibilidades de enfrentamento da violação de direitos vivenciada pelo usuário. Informe, ainda como o usuário vê a possibilidade do acolhimento institucional"
                  :required="false" />
              </div>
              <div class="col-lg-12">
                <form-file @submit="submitFile" multiple btn-text="Iniciar" :progress="progressCompleted" />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="row">
        <hr>
      </div>


      <div class="row pt-1 px-2 d-flex justify-content-end">
        <button @click="submit" class="btn btn-success btn-submit">
          <i class="fas fa-check" />
          Incluir
        </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      loading: false,
      violacoes: [],
      servicos: [],
      data: {},
      files: {},
      raca: this.$root.arrays.cor_raca,
      genero: this.$root.arrays.genero,
      profissao: this.$root.arrays.profissao_principal,
      programa: this.$root.arrays.programas,
      dependencia: this.$root.arrays.acolhimento_grau_dependencia,
      pergunta: this.$root.arrays.pergunta
    };
  },
  mounted() {
    this.getViolacoes();
    this.getServicos();
    this.data.unidade_id = this.item.unidade.id
  },
  methods: {
    checarPrograma() {
      console.log(this.data);
    },
    getViolacoes() {
      axios
        .get(`api/dashboard/get/violencias`)
        .then((response) => {
          this.violacoes = response.data;
        })
    },
    getServicos() {
      axios
        .get(`api/dashboard/atendimento/servicos`)
        .then((response) => {
          this.servicos = response.data;
        })
    },
    submitFile(files) {
      this.files = files;
    },
    submit() {
      this.loading = true;
      let formData = new FormData();
      for (const i of Object.keys(this.data)) {
        formData.append(i, this.data[i]);
      }
      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("anexos[]", this.files[i]);
        }
      } else {
        formData.append("anexos", this.files);
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios.post(`api/dashboard/acolhimento/crianca/gerenciar/vagas`, formData, {
        header: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (event) => {
          let progress = Math.round(
            (event.loaded * 100) / event.total
          );
          this.progressCompleted = progress;
        },
      }).then(response => {
        ladda.stop();
        this.$snack.success({
          button: false,
          text: response.data.data.message,
        });
      })

      /*
      axios.post('api/dashboard/acolhimento/idoso/gerenciar/vagas',
        this.data
      ).then(response => {
        this.$emit('reload')
      })
      */
    },
  }
};
</script>
 